import { escapeHtml } from './helpers';

const BADGE_LABEL: Record<string, string> = {
  new: 'Новинка',
  hit: 'Хит',
  sale: 'Скидка',
};

const BADGE_CSS_CLASS: Record<string, string> = {
  new: 'product-badge--new',
  hit: 'product-badge--hit',
  sale: 'product-badge--sale',
};

const GRID_BADGE_ORDER = ['new', 'hit', 'sale'];

export function badgeMarketingLabel(b: string, oldPrice: number | null, price: number): string {
  if (b === 'sale' && oldPrice !== null && oldPrice > price) {
    return `\u2212${Math.round((1 - price / oldPrice) * 100)}%`;
  }
  return BADGE_LABEL[b] ?? b;
}

export function orderedGridBadges(badges: string[] | undefined): string[] {
  const list = badges ?? [];
  const set = new Set(list);
  const out: string[] = [];
  for (const b of GRID_BADGE_ORDER) {
    if (set.has(b)) out.push(b);
  }
  for (const b of list) {
    if (!GRID_BADGE_ORDER.includes(b)) out.push(b);
  }
  return out;
}

/** Плитка каталога / modal / PDP / shelf: Шт. N + маркетинг (v3.1) */
export function renderGridBadgeStack(
  badges: string[],
  oldPrice: number | null,
  price: number,
  stock: number,
): string {
  const items = [`<span class="product-badge product-badge--stock">Шт. ${stock}</span>`];
  for (const b of orderedGridBadges(badges)) {
    const label = badgeMarketingLabel(b, oldPrice, price);
    const cls = BADGE_CSS_CLASS[b] ?? '';
    items.push(`<span class="product-badge ${cls}">${escapeHtml(label)}</span>`);
  }
  return `<div class="product-badges">${items.join('')}</div>`;
}
